import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
    return (
        <div className="div-footer">
            &nbsp;&copy;2024&nbsp;Shoreline Bridge&nbsp;(v0.5)&nbsp;
        </div>
    );
};

export default Footer;